import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { INVOICES_GET_MANY, WAREHOUSE_TASK_GET_ONE, WAREHOUSE_TASK_ITEMS_GET_MANY } from 'api/query-keys.ts';
import type { TWarehouseTaskRes, TUpdateWarehouseTaskStatusReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateWarehouseTaskStatus = (whTaskId: number) => {
  const queryClient = useQueryClient();

  return useMutationBase<TWarehouseTaskRes, unknown, TUpdateWarehouseTaskStatusReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TWarehouseTaskRes>(`/v1/warehouse-tasks/${whTaskId}/status`, variables);

      return res.data;
    },

    invalidateCallback: (data) => {
      const invalidateKeys = [];

      if (data.status === 'done') {
        invalidateKeys.push([WAREHOUSE_TASK_ITEMS_GET_MANY, data.id]);
      }

      invalidateKeys.push([WAREHOUSE_TASK_GET_ONE, data.id]);

      return invalidateKeys;
    },
    onSuccess: (data) => {
      if (data.status === 'done') {
        queryClient.invalidateQueries({
          queryKey: [INVOICES_GET_MANY],
          predicate: (query) => {
            const [, , , queryString] = query.queryKey;
            if (typeof queryString !== 'string') return false;

            const params = new URLSearchParams(queryString);
            const taskId = params.get('filter[warehouseTaskId]');

            return taskId === String(data.id);
          },
        });
      }
    },
  });
};
